import { SignOutButton } from "@clerk/react";
import { Hourglass } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PendingPage({ me }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
      <div className="max-w-md rounded-3xl border border-slate-200 bg-white p-8 text-center shadow-sm rise" data-testid="pending-approval-card">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-50"><Hourglass className="h-7 w-7 text-amber-600" /></div>
        <h1 className="text-2xl font-extrabold">Waiting for approval</h1>
        <p className="mt-2 text-sm text-slate-600">
          You're signed in as <b>{me.email}</b>. Ask the pharmacy owner or manager to give you access on the Team page, then refresh.
        </p>
        <div className="mt-6 flex justify-center gap-2">
          <Button variant="outline" onClick={() => window.location.reload()} data-testid="pending-refresh-button">Refresh</Button>
          <SignOutButton><Button data-testid="pending-signout-button">Sign out</Button></SignOutButton>
        </div>
      </div>
    </div>
  );
}
